import Modal from "./Modal";
import { ModalSizes, ModalSizeOptions } from "./ModalSizes";

export { ModalSizes, ModalSizeOptions };
export default Modal;
